/**
 * @file TextField.tsx
 * @description Текстовое поле настроек вида сайта (phase19.16 Р1;
 * uiux-design-r1 §4, §5, §7): подпись, поле или многострочное поле,
 * счётчик «7/40», подсказка под полем и предупреждение (не ошибка — сайт
 * сохранит, но стоит поправить: «Поиск покажет первые ~160 знаков…»).
 */

import { useId } from "react";

import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";

interface Props {
  label: string;
  value: string | null | undefined;
  onChange: (value: string) => void;
  /** Жёсткий предел (поле не даст ввести больше). */
  max?: number;
  /** Мягкий предел: после него — `softText` (без запрета). */
  softMax?: number;
  softText?: string;
  hint?: string;
  error?: string | null;
  placeholder?: string;
  multiline?: boolean;
  disabled?: boolean;
}

export function TextField({ label, value, onChange, max, softMax, softText, hint, error, placeholder, multiline = false, disabled = false }: Props) {
  const id = useId();
  const text = value ?? "";
  const over = softMax !== undefined && text.length > softMax;
  const common = {
    id,
    value: text,
    placeholder,
    maxLength: max,
    disabled,
    "aria-invalid": !!error,
    "aria-describedby": `${id}-hint`,
  };
  return (
    <div className="flex flex-col gap-1">
      <Label htmlFor={id}>{label}</Label>
      {multiline ? (
        <Textarea {...common} rows={3} onChange={(e) => onChange(e.target.value)} />
      ) : (
        <Input {...common} onChange={(e) => onChange(e.target.value)} />
      )}
      <div id={`${id}-hint`} className="flex flex-wrap justify-between gap-x-3">
        <span className="type-caption text-on-surface-variant">{error ? null : hint}</span>
        {max ? (
          <span className="type-caption tabular-nums text-on-surface-variant">
            {text.length}/{max}
          </span>
        ) : null}
      </div>
      {error ? <p className="type-caption text-destructive">{error}</p> : null}
      {!error && over && softText ? <p className="type-caption text-warning">{softText}</p> : null}
    </div>
  );
}
